import React, { FC, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from './logo.png';

import svodkaIcon from './svodka.svg';
import svodkaIconActive from './svodka_act.svg';
import burenieIcon from './burenie.svg';
import burenieIconActive from './burenie_act.svg';
import streamIcon from './stream.svg';
import streamIconActive from './stream_act.svg';
import narusheniyaIcon from './narusheniya.svg';
import narusheniyaIconActive from './narusheniya_act.svg';
import chartsIcon from './charts.svg';
import chartsIconActive from './charts_act.svg';
import npvIcon from './npv.svg';
import npvIconActive from './npv_act.svg';
import skvaicon from './skva.svg';
import skvaiconActive from './skva_act.svg';
import settingsIcon from './settings.png';
import settingsIconActive from './settings_act.png';

interface NavItem {
    name: string;
    icon: string;
    activeIcon: string;
    route: string;
}

interface NavItemProps extends NavItem {
    isActive: boolean;
    onClick: () => void;
}

const navItems: NavItem[] = [
    { name: 'Сводка', icon: svodkaIcon, activeIcon: svodkaIconActive, route: '/' },
    { name: 'Бурение', icon: burenieIcon, activeIcon: burenieIconActive, route: '/charts' },
    { name: 'Трансляция', icon: streamIcon, activeIcon: streamIconActive, route: '/streams' },
    { name: 'Нарушения', icon: narusheniyaIcon, activeIcon: narusheniyaIconActive, route: '/violations' },
    { name: 'НПВ', icon: npvIcon, activeIcon: npvIconActive, route: '/analytics' },
    { name: 'Статистика', icon: chartsIcon, activeIcon: chartsIconActive, route: '/statistics' },
    { name: 'Скважины', icon: skvaicon, activeIcon: skvaiconActive, route: '/well' },
];

const NavItemComponent: FC<NavItemProps> = ({ icon, activeIcon, name, isActive, onClick }) => (
    <div
        onClick={onClick}
        style={{
            width: '100%',
            height: 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
        }}
        title={name}
    >
        <div
            style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: isActive ? '#2E3749' : 'transparent',
                transition: 'background 0.2s',
            }}
        >
            <img src={isActive ? activeIcon : icon} alt={name} style={{ width: 24, height: 24 }} />
        </div>
    </div>
);

interface SidebarProps {
    onNavChange: (name: string) => void;
}

export const Sidebar: FC<SidebarProps> = ({ onNavChange }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeRoute, setActiveRoute] = useState<string>(location.pathname);

    useEffect(() => {
        const currentPath = location.pathname;
        setActiveRoute(currentPath);
        const activeItem = navItems.find(item => item.route === currentPath);
        if (activeItem) {
            onNavChange(activeItem.name);
        } else if (currentPath === '/settings') {
            onNavChange('Настройки');
        } else if (currentPath.startsWith('/statistics')) {
            onNavChange('Статистика');
        } else if (currentPath.startsWith('/streams')) {
            onNavChange('Трансляция');
        }
    }, [location, onNavChange]);

    const handleNav = (item: NavItem): void => {
        navigate(item.route);
    };

    return (
        <aside style={{
            width: 60,
            background: '#141928',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '12px 0',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 10,
        }}>
            <div style={{ marginBottom: 24 }}>
                <img src={logo} alt="Logo" style={{ width: 32 }} />
            </div>

            <nav style={{ display: 'flex', flexDirection: 'column', gap: 0, width: '100%' }}>
                {navItems.map((item) => (
                    <NavItemComponent
                        key={item.name}
                        {...item}
                        isActive={activeRoute === item.route || (item.route !== '/' && activeRoute.startsWith(item.route))}
                        onClick={() => handleNav(item)}
                    />
                ))}
            </nav>

            {/* Bottom settings button */}
            <div
                onClick={() => navigate('/settings')}
                style={{
                    marginTop: 'auto',
                    width: '100%',
                    height: 56,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
                title="Настройки"
            >
                <div
                    style={{
                        width: 48,
                        height: 48,
                        borderRadius: 12,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: activeRoute === '/settings' ? '#2E3749' : 'transparent',
                        transition: 'background 0.2s',
                    }}
                >
                    <img
                        src={activeRoute === '/settings' ? settingsIconActive : settingsIcon}
                        alt="Настройки"
                        style={{ width: 24, height: 24 }}
                    />
                </div>
            </div>
        </aside>
    );
};